import React, { memo } from 'react';

import KText from './Text';

import { KColors } from '../../constants';
import KContainer from '../Container';
import KImage from '../Image';
import { KTextProps } from '../types';

interface IProps extends KTextProps {
  withIcon?: boolean;
  colorIcon?: any;
  alignItemsWrap?:
    | true
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'stretch'
    | 'baseline';
}

const KError = (props: IProps) => {
  const {
    withIcon,
    alignItemsWrap = 'flex-end',
    colorIcon = KColors.danger.normal,
    ...rest
  } = props;

  if (withIcon) {
    return (
      <KContainer.View row alignItems={alignItemsWrap}>
        <KImage.MuiIcon icon="WarningAmber" color={colorIcon} size={20} />

        <KText
          paddingH="0.5rem"
          italic
          color={KColors.danger.normal}
          {...rest}
        />
      </KContainer.View>
    );
  }

  return <KText typo="TextXsNormal" color={KColors.danger.normal} {...rest} />;
};

KError.displayName = 'KParagraph';

export default memo(KError);
